/* import __COLOCATED_TEMPLATE__ from './class-group-links.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { action } from '@ember/object';
import { map } from 'rsvp';

export default class ClassGroupLinkComponent extends Component 
{
	@service() config;
	
	@computed('config')
	get host() 
	{
		return this.config.get('resultsBackendProtocol')+"://"+this.config.get('resultsBackendHost')+":"+this.config.get('resultsBackendPort');
	}
	
	@computed('config')
	get namespace() 
	{
		return this.config.get('resultsBackendNamespace');
	}
	
	@action
	async populateLaps()
	{
		const classGroup = this.args.classgroup;
		const course = await classGroup.CourseId;
		const cElements = await course.courseElementsInCourseOrder;

		const courseTimingPoints = await map(cElements, async (ce) => {
			const ceTP = await ce.IntermediateTimingPointId;
			return { ce, tp: ceTP };
		});

		for (const ctp of courseTimingPoints) {
			let lap = 0;
			let reachedCE = false;
			for (const ctp2 of courseTimingPoints) {
				if (ctp2.tp.id == ctp.tp.id && !reachedCE) {
					if (ctp2.ce.id == ctp.ce.id) {
						reachedCE = true;
					}
					lap++;
				}
			}
			ctp.ce.set('lap', lap);
		}
	}
}